import { render, staticRenderFns } from "./properties-block-faq-list.vue?vue&type=template&id=7bda519d&scoped=true"
import script from "./properties-block-faq-list.vue?vue&type=script&lang=js"
export * from "./properties-block-faq-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda519d",
  null
  
)

export default component.exports